export const getUrlCurrentPath = () => window.location.href?.split(/[/ ]+/);

export const permissionErrorContent = {
  default: 'requestAccessMessageDefault',
  result: 'requestAccessMessageResult',
};
